<div class="loading-indicator" #loadingContainer>
    <kendo-loader [type]="'infinite-spinner'"></kendo-loader>
</div>
